import React, { createContext, useState } from "react";

export type UserContextType = {
  user: User;
  setUser: any;
};

type UserContextProviderType = {
  children: React.ReactNode;
};
export const UserContext = createContext({} as UserContextType);

export const UserContextProvider = ({ children }: UserContextProviderType) => {
  const [user, setUser] = useState<User>({
    name: "",
    phoneNumber: "",
    lastName: "",
    companyName: "",
    email: "",
  });

  return (
    <UserContext.Provider value={{ setUser, user }}>
      {children}
    </UserContext.Provider>
  );
};
